import React, { FC, useMemo } from 'react';
import { Link } from '@loomstateorg/shared-frontend';
import { ImageApi, LogoScale } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/types';
import { Reference } from 'types/reference';
import Image, { NextFrontasticImage } from 'frontastic/lib/image';

const BASE_WIDTH = 120;
const BASE_HEIGHT = 40;

export interface Props {
  logo: NextFrontasticImage;
  logoLink: Reference;
  imageClassName?: string;
  src: string;
  logoScale?: LogoScale;
  imageObjectPosition?: string;
  imageApi?: ImageApi;
  onClick?: () => void;
  children?: React.ReactNode;
}

const HeaderLogo: FC<Props> = ({
  logoLink,
  logo,
  imageClassName,
  src,
  logoScale = '1x',
  imageObjectPosition = 'left',
  imageApi = 'fill',
  onClick,
}) => {
  const dimensions = useMemo(() => {
    const n = parseFloat(logoScale) || 1;
    return { width: BASE_WIDTH * n, height: BASE_HEIGHT * n };
  }, [logoScale]);

  return (
    <div className="relative" data-testid="icon-menu-item" onClick={onClick}>
      <Link className={imageClassName} style={dimensions} link={logoLink} data-testid="home">
        {imageApi === 'layout' ? (
          <Image
            src={src}
            media={logo?.media}
            layout="fill"
            objectFit="contain"
            objectPosition={imageObjectPosition}
            alt={logo?.title || 'Logo'}
          />
        ) : (
          <Image
            src={src}
            media={logo?.media}
            fill
            style={{ objectFit: 'contain', objectPosition: imageObjectPosition }}
            alt={logo?.title || 'Logo'}
          />
        )}
      </Link>
    </div>
  );
};

export default HeaderLogo;
